import type { RouteParamsGeneric } from '#vue-router'
import type { SummarizeData } from '@brighterly/lib-core-types/ai-summarize/interfaces'

import { useCommonStore } from '@stores/common'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface AiSummaryPayload {
  params:   RouteParamsGeneric
}

interface AiSummaryApiOptions {
  onStart?: () => void
  onSuccess?: (disciplineInfo: any) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useAiSummaryApi = async (payload: AiSummaryPayload, options?: AiSummaryApiOptions): Promise<SummarizeData | null> => {
  const { $axios } = useNuxtApp()

  const commonStore = useCommonStore()

  const bookingId = payload.params.summarize || ''

  const url = useCsRoutes('bookings.ai-summary', {
    '[booking_id]': bookingId,
  })

  options?.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const summarizeInfo = data.data.ai_summary || null

    commonStore.setLoading(false)
    options?.onSuccess?.(summarizeInfo)

    return summarizeInfo
  } catch (err) {
    console.error(err)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
